import { render } from "./bank-cheques.vue?vue&type=template&id=551897bd&scoped=true"
import script from "./bank-cheques.vue?vue&type=script&lang=js"
export * from "./bank-cheques.vue?vue&type=script&lang=js"

import "./bank-cheques.vue?vue&type=style&index=0&id=551897bd&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551897bd"]])

export default __exports__